/**
 * Table of contents scroll-spy.
 *
 * Highlights whichever entry corresponds to the section currently under the
 * top of the viewport.
 *
 * No optional chaining or nullish coalescing: gulp-babel has no preset
 * configured, so uglify-js parses this as written.
 */
(function () {
  const links = document.querySelectorAll(".toc a");
  if (!links.length) return;
  const targets = [];
  for (let i = 0; i < links.length; i++) {
    const href = links[i].getAttribute("href");
    if (!href || href.charAt(0) !== "#") continue;
    // getElementById rather than querySelector: an id that is legal in HTML
    // but not a valid CSS selector (one starting with a digit, say) would
    // make querySelector throw.
    const el = document.getElementById(href.slice(1));
    if (el) targets.push({
      link: links[i],
      el: el
    });
  }
  if (!targets.length) return;
  function spy() {
    // Matches the scroll-margin-top used by the anchor targets, so the entry
    // lights up exactly when its section settles below the fixed header.
    const line = window.pageYOffset + 170;
    let active = targets[0];
    for (let i = 0; i < targets.length; i++) {
      if (targets[i].el.getBoundingClientRect().top + window.pageYOffset <= line) {
        active = targets[i];
      } else {
        break;
      }
    }
    for (let i = 0; i < targets.length; i++) {
      targets[i].link.classList.toggle("toc-on", targets[i] === active);
    }
  }
  let queued = false;
  window.addEventListener("scroll", function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      spy();
      queued = false;
    });
  }, {
    passive: true
  });
  spy();
})();